<template>
  <img
    :class="['m-responsive-image', { [lazyLoadedClass]: lazy && loaded }]"
    v-bind="imgProps"
  >
</template>

<script>
import elementInViewport from 'element-in-viewport'
import { buildURL } from './../../../helpers/media'

export default {
  name: 'UtilsResponsiveImage',
  props: {
    alt: {
      type: String,
      default: ''
    },
    path: { // will be used with cloudfrontPattern to generate srcset
      type: String,
      default: ''
    },
    cloudfrontPattern: {
      type: String,
      default: 'https://dkyhanv6paotz.cloudfront.net/live/fit-in/{width}x{height}/medias/nfb_tube/{path}'
    },
    imgFormatSizes: {
      type: Array,
      default: () => {
        return [340, 420, 680, 860, 1200, 1500]
      }
    },
    srcsetSizes: {
      type: String,
      default: '96vw'
    },
    absoluteUrl: { // will be used instead of path/cloudfronPattern
      type: String,
      default: ''
    },
    lazy: {
      type: Boolean,
      default: false
    },
    lazyLoadedClass: {
      type: String,
      default: 'is-loaded'
    }
  },
  data () {
    return {
      loaded: false
    }
  },
  computed: {
    srcset () {
      if (!this.path || !this.cloudfrontPattern || this.absoluteUrl) {
        return false
      }

      return this.imgFormatSizes.map(width => {
        return `${buildURL(this.cloudfrontPattern, { width, path: this.path })} ${width}w`
      }).join(', ')
    },
    src () {
      if (this.absoluteUrl) {
        return this.absoluteUrl
      }

      if (!this.path || !this.cloudfrontPattern) {
        // return default one?
      }

      return buildURL(this.cloudfrontPattern, { width: this.imgFormatSizes[0], path: this.path })
    },
    imgProps () {
      const props = {
        alt: this.alt
      }

      if (this.lazy) {
        props['data-src'] = this.src
      } else {
        props.src = this.src
      }

      if (this.srcset) {
        if (this.lazy) {
          props['data-srcset'] = this.srcset
        } else {
          props.srcset = this.srcset
        }
        props.sizes = this.srcsetSizes
      }

      return props
    }
  },
  mounted () {
    if (this.lazy) {
      this.initLazy()
    }
  },
  methods: {
    initLazy () {
      elementInViewport(this.$el)
        .then(this.loadSrc)
    },
    loadSrc () {
      this.$el.addEventListener('load', this.onLoaded)
      if (this.$el.dataset.srcset) {
        this.$el.srcset = this.$el.dataset.srcset
        this.$el.removeAttribute('data-srcset')
      }
      this.$el.src = this.$el.dataset.src
      this.$el.removeAttribute('data-src')
    },
    onLoaded () {
      this.$el.removeEventListener('load', this.onLoaded)
      this.loaded = true
    }
  }
}
</script>

<style lang="less">
@import (reference) "./../../../less/shared/utilities.less";
.m-responsive-image {
  display: block;
  width: 100%;
}
</style>
